// OLD DO NOT USE -- WON'T WORK ;)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as BookingService from '_services/booking-service';

const initialState = {
    booking: null,
    transactions: null,
    status: 'idle',
    error: null
};

// get bookings for user
export const getBookings = createAsyncThunk('bookings/getUserBookings', async (booking_id) => {
    return BookingService.getUserBookings(booking_id);
});

// fetch bookings data
export const getTransactions = createAsyncThunk('bookings/getTransactions', async (uid) => {
    return BookingService.getTransactions(uid);
})


const qrHandlerSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: {
        [getBookings.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getBookings.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              booking: action.payload,
            }
        },
        [getBookings.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message,
            }
        },
        [getTransactions.pending]: (state, action) => {
            return {
              ...state,
              status: 'loading',
            }
        },
        [getTransactions.fulfilled]: (state, action) => {
            return {
              ...state,
              status: 'succeeded',
              transactions: action.payload,
            }
        },
        [getTransactions.rejected]: (state, action) => {
            return {
              ...state,
              status: 'failed',
              error: action.error.message
            }
        },
    }
});

export const { reset } = qrHandlerSlice.actions;
export const selectUserBooking = state => state.booking.booking;
export const selectTransactions = state => state.booking.transactions;
export const selectQrHandlerStatus = state => state.booking;
export default qrHandlerSlice.reducer;
